module.exports = __webpack_public_path__ + "img/deco_exclamation_big.b9835dc0.svg";